<template>
  <div class="mobileMainNav">
    <MobileHamburgerMenu :expanded="currentSection === 'Menumobile'" />
    <nav v-show="!isNavFixed" id="navigation-normal" ref="navbar" class="navbar" role="navigation" aria-label="main navigation" :style="backgroundStyles">
      <div ref="navbarWrapper" class="container">
        <!-- MOBILE and TABLET Nav -->
        <div class="navbar-mobile">
          <!-- LOGO -->
          <a href="/" alt="TTT Logo" class="navbar-icon homenav-icon">
            <Logo size="small" :color="colorOption" />
          </a>

          <!-- Phone icon -->
          <a v-if="isOfficeOpen" :href="`tel:${officePhoneNumber}`" alt="phone" class="navbar-icon custom-phone-icon">
            <Phone :color="colorOption" />
          </a>
          <!-- Callback icon -->
          <a v-if="!isOfficeOpen" href="https://bookings.thethinkingtraveller.com/portal-embed#/customer/callbacks" target="_blank" class="navbar-icon custom-phone-icon">
            <Callback :color="colorOption" />
          </a>

          <!-- Heart icon -->
          <div ref="navbarItemShortlistIcon" class="navbar-icon navbar-mobile--icon" @click="openSection($event, sections.end.shortlist.name, sections.end.shortlist.id)">
            <Shortlist :expanded="currentSection === sections.end.shortlist.name" />
            <ShortlistCounter :color="colorOption" :isActive="currentSection === sections.end.shortlist.name" />
          </div>

          <!-- Hamburger icon -->
          <div ref="navbarItemHamburgerIcon" class="navbar-item navbar-icon navbar-mobile--icon" :class="{'is-active': isMobileMenuActive}" @click="toggleSection($event, 'Menumobile', 6)">
            <Hamburger v-if="isMobileMenuActive !== true" :color="colorOption" />
            <Cross v-if="isMobileMenuActive === true" :color="colorOption" />
          </div>
        </div>
      </div>
    </nav>

    <!-- FIXED NAV -->

    <nav v-show="isNavFixed" id="navigation-fixed" ref="navbar" :class="`navbar ${isNavFixed ? 'navbar-fixed' : ''}`" role="navigation" aria-label="main navigation">
      <div ref="navbarWrapper" class="container">
        <!-- MOBILE and TABLET Sticky Nav -->
        <div class="navbar-mobile mobile" :style="backgroundStyles">
          <!-- LOGO -->
          <a href="/" alt="TTT Logo" class="navbar-icon homenav-icon">
            <Logo size="small" :color="'dark'" />
          </a>

          <!-- Phone icon -->
          <a v-if="isOfficeOpen" :href="`tel:${officePhoneNumber}`" alt="phone" class="navbar-icon">
            <Phone :color="'dark'" />
          </a>
          <!-- Phone icon -->
          <a v-if="!isOfficeOpen" href="https://bookings.thethinkingtraveller.com/portal-embed#/customer/callbacks" target="_blank" class="navbar-icon">
            <Callback :color="'dark'" />
          </a>

          <!-- Shortlist icon -->
          <div ref="navbarItemShortlistIcon" class="navbar-icon" @click="openSection($event, sections.end.shortlist.name, sections.end.shortlist.id)">
            <Shortlist :expanded="currentSection === sections.end.shortlist.name" />
            <ShortlistCounter :color="'dark'" :isActive="currentSection === sections.end.shortlist.name" />
          </div>

          <!-- Hamburger icon -->
          <div ref="navbarItemHamburgerIcon" class="navbar-item navbar-icon navbar-mobile--icon" :class="{'is-active': isMobileMenuActive}" @click="toggleSection($event, 'Menumobile', 6)">
            <Hamburger v-if="isMobileMenuActive !== true" :color="colorOption" />
            <Cross v-if="isMobileMenuActive === true" :color="colorOption" />
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Logo from '../icons/logo';
import Phone from '../icons/Phone';
import Callback from '../icons/Callback';
import ShortlistCounter from './Shortlist/ShortlistCounter.vue';
import MobileHamburgerMenu from './MobileHamburgerMenu.vue';
import Shortlist from './Shortlist/Shortlist';
import closeTab from '../../mixins/closeTab';
import Hamburger from '../icons/Hamburger';
import Cross from '../icons/Cross';

export default {
  name: 'MobileMainNav',
  components: {
    Logo,
    Phone,
    Callback,
    ShortlistCounter,
    MobileHamburgerMenu,
    Shortlist,
    Hamburger,
    Cross,
  },
  mixins: [
    closeTab,
  ],
  props: {
    backgroundStyles: {
      type: Object,
      required: false,
    },
    isFullHeight: {
      type: Boolean,
      required: false,
    },
    isFullHeightDark: {
      type: Boolean,
      required: false,
    },
    isOfficeOpen: {
      type: Boolean,
      required: false,
    },
    officePhoneNumber: {
      type: String,
      required: false,
    },
    sections: {
      type: Object,
      required: false,
    },
    currentSection: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    strokeColor: {
      type: String,
      required: false,
    },
    colorOption: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    isNavFixed() {
      return this.$store.getters['common/getNavfixed'];
    },
    isMobileMenuActive() {
      return this.currentSection === 'Menumobile';
    },
  },
  watch: {
    isNavFixed: {
      handler(val) {
        if (this.isFullHeight) {
          this.active = val;
        }
        else {
          this.active = true;
        }
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    toggleSection(ev, sectionName, sectionId) {
      if (this.currentSection === sectionName) {
        if (!sectionName === 'Menumobile') {
          this.$store.commit('common/showOverlay', true);
        }
        this.$store.commit('common/closeSection', '');
        this.closeTab(ev);
      } else {
        if (!sectionName === 'Menumobile') {
          this.$store.commit('common/showOverlay', true);
          document.body.classList.add('modal-open');
        }
        this.closeTab(ev);
        this.$store.commit('common/openSection', sectionName);
        this.$store.commit('common/showOverlay', true);
        this.$store.commit('common/setSearchwide', false);
        document.body.classList.add('modal-open');
      }
    },
    openSectionFromBanner(val) {
      this.openSection(val, this.sections.end.shortlist.name, this.sections.end.shortlist.id);
      // Hack to get around ClickOutside
      this.clickedFromOutsideMain = true;
      setTimeout(() => {
        this.clickedFromOutsideMain = false;
      }, 100);
    },
    openSection(ev, sectionName, sectionId) {
      console.log('section', sectionName);
      if (sectionName === 'Menumobile' || sectionName === 'Search') {
        this.$store.commit('common/openSection', sectionName);
        this.$store.commit('common/openMobileSection', 0);
        this.$store.commit('common/showOverlay', true);
        document.body.classList.add('modal-open');
      } else {
        if (this.currentSection !== sectionName) {
          this.$store.commit('common/openSection', sectionName);
          this.$store.commit('common/showOverlay', true);
          this.$store.commit('common/setSearchwide', false);
          document.body.classList.add('modal-open');
        } else {
          this.closeTab(ev);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .custom-phone-icon {
    height: 20px;
  }
</style>
